import { render, staticRenderFns } from "./HighlightsBanner.vue?vue&type=template&id=988b5fa6&scoped=true&"
import script from "./HighlightsBanner.vue?vue&type=script&lang=js&"
export * from "./HighlightsBanner.vue?vue&type=script&lang=js&"
import style0 from "./HighlightsBanner.vue?vue&type=style&index=0&id=988b5fa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988b5fa6",
  null
  
)

export default component.exports